// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_c6-3";
export var flatBottomCorners = "_c6-5";
export var productImage = "_c6-0";
export var quantityContainer = "_c6-2";
export var quantityHeader = "_c6-6";
export var tooltip = "_c6-1";
export var wrapAndEllipsesOverflow = "_c6-4";